import PropTypes from 'prop-types'
import { DefaultList } from './Default/index'
import { SlicedList } from './Sliced/index'
import { ComparedList } from './Compared/index'

// SuperCard Default List
export const Default = ({ details, k, redirectLink }) => {
  return (
    <DefaultList details={details} k={k} redirectLink={redirectLink} />
  )
}

Default.propTypes = {
  details: PropTypes.object,
  k: PropTypes.any,
  redirectLink: PropTypes.any
}
// End of SuperCard Default List

// SuperCard Sliced List
export const Sliced = ({ details, k, redirectLink }) => {
  return (
    <SlicedList details={details} k={k} redirectLink={redirectLink} />
  )
}

Sliced.propTypes = {
  details: PropTypes.object,
  k: PropTypes.any,
  redirectLink: PropTypes.any
}
// End of SuperCard Sliced List

// SuperCard Compared List
export const Compared = ({ details, k, redirectLink }) => {
  return (
    <ComparedList details={details} k={k} redirectLink={redirectLink} />
  )
}

Compared.propTypes = {
  details: PropTypes.object,
  k: PropTypes.any,
  redirectLink: PropTypes.any
}
// End of SuperCard Compared List
